class Elementor_Team_Carousel{
    static instance;

    static getInstance() {
        if (!Elementor_Team_Carousel.instance) {
            Elementor_Team_Carousel.instance = new Elementor_Team_Carousel();
        }
        return Elementor_Team_Carousel.instance;
    }

    constructor(){
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init(){
        elementorFrontend.hooks.addAction( 'frontend/element_ready/opal-team-box.default', ( $scope ) => {
            let $carousel = $scope.find('.owl-carousel');
            if($carousel.length > 0){
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        } );
    }
}


Elementor_Team_Carousel.getInstance();